import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router';
import { useCollection, useRecord, useSession } from '../../data/hooks.tsx';
import { useOpenRecord } from '../windows/hooks.ts';
import { RecordView } from './RecordView.tsx';

/**
 * A record's address (`/p/…/r/…`), used by links from outside the app: it opens the record in a
 * window over its collection. Full-page records are switched off for now; `RecordView`'s page
 * mode and the `.record-page` styles stay for when they come back.
 */
export function RecordPage() {
  const { recordId = '' } = useParams();
  const session = useSession();
  const record = useRecord(recordId);
  const collection = useCollection(record?.collectionId);
  const openRecord = useOpenRecord();
  const navigate = useNavigate();
  const ready = !!record && !!collection;

  useEffect(() => {
    if (!ready || !collection) return;
    openRecord(recordId, { collectionId: collection.id, viewId: collection.views[0]?.id ?? '' });
    navigate(`/p/${session.id}/c/${collection.id}`, { replace: true });
  }, [ready, collection, recordId, openRecord, navigate, session.id]);

  if (ready) return null;
  // Missing, or not synced yet: the window opens as soon as it arrives.
  return (
    <div className="record-page">
      <RecordView recordId={recordId} mode="page" />
    </div>
  );
}
